import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lucky-numbers-view" }
const _hoisted_2 = { class: "header-filters" }

import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SectionHeader from '@/components/base/SectionHeader.vue'
import LotteryFilters from '@/components/LotteryFilters.vue'
import LuckyNumbersSection from '@/components/LuckyNumbersSection.vue'
import BetBuilderPanel from '@/components/BetBuilderPanel.vue'
import { useUpcomingDrawsStore } from '@/stores/upcomingDraws'
import { useIntegrationMode } from '@/composables/useIntegrationMode'
import type { UpcomingDraw } from '@/types/lottery'


export default /*@__PURE__*/_defineComponent({
  __name: 'LuckyNumbersView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const upcomingDrawsStore = useUpcomingDrawsStore()
const { isLite } = useIntegrationMode()
const favorites = ref<UpcomingDraw[]>([])
const searchQuery = ref('')
const selectedCountry = ref('')

const activeCountrySlugs = computed(() => {
  const slugs = new Set<string>()
  for (const draw of upcomingDrawsStore.draws || []) {
    if (draw?.country) slugs.add(String(draw.country).toLowerCase())
  }
  return Array.from(slugs)
})

const handleSearch = (query: string) => {
  searchQuery.value = query
}

const handleCountryFilter = (country: string) => {
  selectedCountry.value = country
}

const handleBet = (draw: UpcomingDraw) => {
  router.push({ path: `/lottery/${draw.game_slug}`, query: route.query })
}

const handleFavorite = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return
  const index = favorites.value.findIndex(fav => fav.id === draw.id)
  if (index === -1) {
    favorites.value.push(draw)
  } else {
    favorites.value.splice(index, 1)
  }
  localStorage.setItem('favoriteDraws', JSON.stringify(favorites.value))
}

const removeLottery = (lotteryToRemove: UpcomingDraw) => {
  const idx = upcomingDrawsStore.draws.findIndex((draw) => draw.id === lotteryToRemove.id)
  if (idx !== -1) {
    upcomingDrawsStore.draws.splice(idx, 1)
    if (upcomingDrawsStore.draws.length === 0) {
      void upcomingDrawsStore.fetchDraws(1)
    }
  }
}

const isFavorited = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return false
  return favorites.value.some(fav => fav.id === draw.id)
}

onMounted(async () => {
  const savedFavorites = localStorage.getItem('favoriteDraws')
  if (savedFavorites) {
    favorites.value = JSON.parse(savedFavorites)
  }
  await upcomingDrawsStore.fetchDraws(1)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionHeader, {
      title: _ctx.$t('sections.luckyNumberGames'),
      subtitle: _unref(isLite) ? '' : _ctx.$t('sections.luckyNumberGamesDescription'),
      variant: "complex"
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LotteryFilters, {
            "active-country-slugs": activeCountrySlugs.value,
            onSearch: handleSearch,
            onFilterCountry: handleCountryFilter
          }, null, 8, ["active-country-slugs"])
        ])
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    (!_unref(isLite))
      ? (_openBlock(), _createBlock(BetBuilderPanel, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(LuckyNumbersSection, {
      games: _unref(upcomingDrawsStore).draws,
      "is-favorited": isFavorited,
      "show-filters": false,
      "search-query": searchQuery.value,
      "selected-country": selectedCountry.value,
      onBet: handleBet,
      onFavorite: handleFavorite,
      onRemove: removeLottery
    }, {
      header: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"display":"none"} }, null, -1)
      ])),
      _: 1
    }, 8, ["games", "search-query", "selected-country"])
  ]))
}
}

})